/* eslint-disable no-constructor-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
export default class CustomError extends Error {
  info?: any;

  status?: number;

  constructor(message: string, info?: any, status?: number) {
    super(message);
    const newTarget = new.target || CustomError;
    const instance = Object.create(newTarget.prototype);

    instance.message = message;
    instance.info = info;
    instance.status = status;

    return instance;
  }
}
